import { Section, DataTable, Kpi, pctFmt, fmtDur } from "./_shared";
import { BarChartC } from "../_charts";

const CALL_COLS = [
  { id: "channel", label: "Channel" }, { id: "total", label: "Total" },
  { id: "answered", label: "Answered" }, { id: "missed", label: "Missed" },
  { id: "answer_rate", label: "Answer %" }, { id: "avg_talk_seconds", label: "Avg Talk" },
];
const EMAIL_COLS = [
  { id: "channel", label: "Channel" }, { id: "received", label: "Received" },
  { id: "new_conversations", label: "New Emails / Threads" }, { id: "replied", label: "Replied" },
  { id: "unanswered", label: "Unanswered" }, { id: "sent", label: "Sent" },
  { id: "reply_rate", label: "Reply %" },
];

export default function OmniChannels({ data }) {
  const rows = data.rows || [];
  const email = rows.filter((r) => r.channel_id === "email");
  const msg = rows.filter((r) => r.channel_id !== "email");
  const pf = { delivery_rate: pctFmt, read_rate: pctFmt, reply_rate: pctFmt };
  const wa = rows.find((r) => r.channel_id === "whatsapp");
  return (
    <div className="space-y-4" data-testid="omni-channels">
      {wa && (
        <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-3" data-testid="omni-wa-kpis">
          <Kpi label="WhatsApp sent" value={wa.sent} testid="omni-wa-sent" />
          <Kpi label="Delivered" value={wa.delivered} hint={`${wa.delivery_rate}%`} testid="omni-wa-delivered" />
          <Kpi label="Read" value={wa.read} hint={`${wa.read_rate}%`} testid="omni-wa-read" />
          <Kpi label="Failed" value={wa.failed} testid="omni-wa-failed" />
          <Kpi label="Received" value={wa.received} testid="omni-wa-received" />
          <Kpi label="Templates sent" value={wa.template_sent} testid="omni-wa-templates" />
        </div>
      )}
      <Section title="Delivery funnel" subtitle="Sent → Delivered → Read, per messaging channel" testid="omni-funnel">
        <BarChartC data={msg} xKey="channel" yKeys={[
          { id: "sent", label: "Sent" }, { id: "delivered", label: "Delivered" },
          { id: "read", label: "Read" }, { id: "failed", label: "Failed" }, { id: "received", label: "Received" }]} />
      </Section>
      <Section title="Messaging channels" testid="omni-msg-card">
        <DataTable columns={data.columns} rows={msg} format={pf} testid="omni-msg-table" />
      </Section>
      <Section title="Email" testid="omni-email-card">
        <DataTable columns={EMAIL_COLS} rows={email} format={pf} testid="omni-email-table" empty="No email activity in this range." />
      </Section>
      <Section title="Calls" testid="omni-calls-card">
        <DataTable columns={CALL_COLS} rows={data.calls || []} testid="omni-calls-table"
          format={{ answer_rate: pctFmt, avg_talk_seconds: fmtDur }} />
      </Section>
      <Section title="Top failure reasons" testid="omni-failures-card">
        <DataTable columns={[{ id: "reason", label: "Reason" }, { id: "channel", label: "Channel" }, { id: "count", label: "Count" }]}
          rows={data.failures || []} testid="omni-failures-table" empty="No failed messages in this range." />
      </Section>
    </div>
  );
}
